import Immutable from 'immutable';
import { CLOUD, DATA_CENTER, SERVER } from "../constants/hostings";
import { PVA } from "../constants/paymentTypes";
import algoliaFacets from "./algolia-facets";
export var sortOptions = Immutable.List([Immutable.Map({
  key: 'topRated',
  label: 'Top rated',
  title: 'Top-rated',
  indexSuffix: function indexSuffix() {
    return 'desc_ratings.ratingsScore';
  }
}), Immutable.Map({
  key: 'trending',
  label: 'Top trending',
  title: 'Trending',
  indexSuffix: function indexSuffix() {
    return 'desc_distribution.deltaInstalls';
  },
  applyOverrides: function applyOverrides(query) {
    return query.addFacetRefinement(algoliaFacets.getIn(['isAtlassian', 'algoliaFacetKey']), 'false');
  }
}), Immutable.Map({
  key: 'topSelling',
  label: 'Top selling',
  title: 'Top-selling',
  indexSuffix: function indexSuffix(_ref) {
    var filters = _ref.filters;

    switch (filters.get('hosting')) {
      case CLOUD:
        return 'desc_sales.recentGrossCloud';

      case SERVER:
        return 'desc_sales.recentGrossServer';

      case DATA_CENTER:
        return 'desc_sales.recentGrossServer';

      default:
        return 'desc_sales.recentGrossTotal';
    }
  },
  applyOverrides: function applyOverrides(query) {
    return query.addFacetRefinement(algoliaFacets.getIn(['isAtlassian', 'algoliaFacetKey']), 'false').addDisjunctiveFacetRefinement(algoliaFacets.getIn(['marketplaceType', 'algoliaFacetKey']), PVA);
  }
}), Immutable.Map({
  key: 'newest',
  label: 'Newest',
  title: 'Newest',
  indexSuffix: function indexSuffix() {
    return 'desc_releaseDate';
  }
})]).reduce(function (acc, s) {
  return acc.set(s.get('key'), s);
}, Immutable.OrderedMap());